import { Descriptions,Button, Typography, PageHeader  } from "antd";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom"
import { useApiContext } from "../../hooks/useApiContext";
import { dateFormat } from "../../utils/Constants";
import ReactToPrint from "react-to-print";
import SalaryPrint from "../../components/salary/SalaryPrint";

export default function SalaryDetails() {
    const {id}= useParams()
    let printRef = useRef();
    const { Title } = Typography;
    const{salaries} = useApiContext()
    const [salaryData, setSalaryData] = useState()
    
    useEffect(()=>{
        if(id) {
            console.log("id", id);
            const data = salaries.find(x=>x.id == id)
            setSalaryData(data)
            console.log("data", data);
        }
    }, [id])
  console.log("state", salaryData);
    return (
        <>
         <PageHeader
          className="site-page-header"
          onBack={() => window.history.back()}
          title="Salary Details"
          subTitle="Find all the salary details here"
          extra={<ReactToPrint trigger={() => <Button type='primary'>Print</Button> } content={() => printRef.current} />}
        />
        
        {salaryData && 
            <>
                <Descriptions bordered  className="projectbg">
              <Descriptions.Item label="Payment date " span={2}>{moment(salaryData.paymentDate).format(dateFormat)}</Descriptions.Item>
              <Descriptions.Item label="Employee Name " span={2}>{salaryData.getEmployee.fullName}</Descriptions.Item>
              <Descriptions.Item label="Basic Salary " span={2}>{salaryData.basicSalary}</Descriptions.Item>
              <Descriptions.Item label="Advance Amount " span={2}>{salaryData.advanceAmount}</Descriptions.Item>
              <Descriptions.Item label="Working Days" span={2}>{salaryData.totalAttendence}</Descriptions.Item>
              <Descriptions.Item label="Overtime in Hours" span={2}>{salaryData.overTimeHours}</Descriptions.Item>
              <Descriptions.Item label="Cost for overtime" span={2}>{salaryData.overTimeCost}</Descriptions.Item>
              <Descriptions.Item label="Bonus" span={2}>{salaryData.bonusAmount}</Descriptions.Item>
              <Descriptions.Item label="Total Earnings" labelStyle={{fontWeight:'bold'}} span={2}>{salaryData.totalAmount}</Descriptions.Item>
              
                  </Descriptions>

                  <div style={{display:'none'}}>
       {
         salaryData && 

         <SalaryPrint
          basicsalary={salaryData.basicSalary} 
          employeeName={salaryData.getEmployee.fullName}
          borderNumber={salaryData.getEmployee.borderNumber}
          projectName={salaryData.project?.projectName}
          salaryDate={salaryData.paymentDate} 
          overTimeHours={salaryData.overTimeHours}
          overTimeHoursCost={salaryData.overTimeCost}
          getFixed={salaryData.bonusAmount}
          advanceAmount={salaryData.advanceAmount}
          calculateSalaryAmount={salaryData.totalAmount}
          ref={printRef}/>
       }
         
      </div>
            </>
        }
            
             
             
        </>
    )
}
